import styled from "styled-components";
import { ButtonProps, getButtonStyle } from "../layout/style/colors";

export const PageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 50px 0 30px;
  overflow-y: auto;
  overflow-x: hidden;

  font-family: Pretendard;
`;

export const PageButtonHeader = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  font-family: Pretendard;
  font-size: 35px;
  font-weight: 700;
  line-height: 41.77px;
  text-align: left;
  padding: 50px 30px 0px 0px;

  > .button {
    cursor: pointer;
    padding: 12px 65px;
    border-radius: 15px;
    background: #7f25fb;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const PageHeader = styled.div`
  position: relative;
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  font-family: Pretendard;
  font-size: 35px;
  font-weight: 700;
  line-height: 41.77px;
  text-align: left;
  padding: 50px 30px 0px 0px;
`;

export const PageContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 6px);
  box-sizing: border-box;
  border-radius: 20px;
  left: 3px;
  padding: 4px 20px 30px;
  font-family: Pretendard;
  height: auto;
  background-color: #f0f3f8;
  margin-top: 30px;
  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const PageContentHeader = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #d9d9d9;

  font-family: Pretendard;
  font-size: 25px;
  font-weight: 600;
  line-height: 29.83px;
  text-align: left;

  background-color: #f0f3f8;
  margin-top: 30px;
  > .title {
    display: flex;
    gap: 20px;

    > .tap {
      width: 149px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      gap: 10px;
      border-radius: 15px;
      opacity: 0px;
      font-family: Pretendard;
      font-size: 20px;
      font-weight: 600;
      color: #bebebe;
      cursor: pointer;

      &.selected {
        background: #7f25fb;
        color: #ffffff;
      }
    }
  }
`;

export const PageContentHeaderActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  font-weight: 700;
`;

export const PageContentHeaderButton = styled.div<ButtonProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  height: 30px;
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 700;
  line-height: 17.9px;
  text-align: center;
  padding: 10px 62px;
  ${({ $weight }) => {
    return `flex:${$weight};`;
  }};
  ${({ $variant }) => getButtonStyle($variant)}
`;

export const TableHeader = styled.div`
  display: flex;
  padding: 20px 15px 20px 65px;
  margin-bottom: 10px;
`;

export const TableContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  > .data-wrapper {
    display: flex;
    align-items: center;
    gap: 20px;

    > .checkbox {
      > .box {
        width: 38px;
        height: 38px;
        border-radius: 6px;
        border: 2px solid #d9d9d9;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
`;

export const TableContent = styled.div<{ select: boolean }>`
  display: flex;
  flex: 1;
  height: 56px;
  padding: 4.59px 15px 4.59px 15px;
  border-radius: 11.47px;
  background: ${({ select }) => (select ? "#7F25FB" : "#fff")};
  box-sizing: border-box;
  align-items: center;
  color: ${({ select }) => (select ? "#fff" : "#121212")};
`;

export const HeaderItem = styled.div<{ weight: any }>`
  flex: ${({ weight }) => weight};
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 500;
`;

export const ColumnItem = styled.div<{ weight: any }>`
  flex: ${({ weight }) => weight};
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 500;

  &.i0 > span {
    padding: 5px 30px;
    height: 22.93px;
    border-radius: 5.73px;
    background: #373636;
    color: #fff;
    line-height: 22.93px;
  }

  &.i2 {
    font-size: 20px;
    font-weight: 700;
  }
`;

export const NormalTimerPopup = styled.div`
  width: 580px;
  height: 310px;
  border-radius: 13px;
  background: #ffffff;
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  padding-top: 70px;

  > .content {
    font-family: Pretendard;
    font-size: 25px;
    font-weight: 400;
    line-height: 35px;
    text-align: center;
    margin-bottom: 63px;

    > span {
      font-weight: 600;
    }
  }

  > .button {
    cursor: pointer;
    margin: 0 auto;
    width: 550px;
    height: 48px;
    border-radius: 8px;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 600;
    line-height: 48px;
    text-align: center;
    background: #d91818;
    color: #fff;
  }
`;

export const PageBox = styled.div`
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: relative;
  box-sizing: border-box;
`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
  width: 28.08px;
  height: 28.08px;
  text-align: center;
  border: 3px solid #d9d9d9;
  border-radius: 4px;
  accent-color: #7f25fb;

  &:before {
    content: "✔";
    font-size: 18px;
    color: #d9d9d9;
  }
`;

export const Title = styled.div<{ size?: number; weight?: number }>`
  font-family: Pretendard;
  font-size: ${(p) => (p.size ? p.size : "23")}px;
  font-weight: ${(p) => (p.weight ? p.weight : "600")};

  > span {
    margin-left: 15px;
    font-size: 16px;
  }
`;
